export const defaultState = {
  startCall: false,
  videoCallPayload: null,
  userExit: false,
};

export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'SET_VIDEO_DATA':
      console.log('SET_VIDEO_DATA', action.payload);
      return Object.assign({}, state, {
        startCall: true,
        videoCallPayload: action.payload,
      });
    case 'RESET_VIDEO_DATA':
      console.log('RESET_VIDEO_DATA');
      return Object.assign({}, state, {
        ...defaultState,
        userExit: action.payload,
      });
    case 'SET_INITIAL_STATE':
      return { ...defaultState };
    default:
      return state;
  }
}
